import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/visa-type');
}
//Get all active
export function allActive(){
    return http().get('/visa-type/active');
}
//Get Single
export function single(id){
    return http().get(`/visa-type/${id}`);
}
//Add one
export function add(data){
    return http().post('/visa-type', data)
}
//Update
export function update(id, data){
    return http().put(`/visa-type/${id}`, data)
}
//Delete one
export function deleteSingle(id){
    return http().delete(`/visa-type/${id}`);
}